import {Component} from '@angular/core';
import {formatCurrency, formatNumber} from '@angular/common';
import {MatDialog} from '@angular/material/dialog';

export interface CreditInterest {
  level: string;
  minimum: number;
  interestPercentage: number;
  linkId: string;
  linkPercentage: number;
  storePercentage: number;
  minimumPercentage: number;
  maximumPercentage: number;
  startDate: string;
}

@Component({
             selector: 'app-detail-table',
             templateUrl: './credit-interest-table.component.html',
             styleUrls: ['../../detail-screen/detail-screen.component.css'],
           })
export class CreditInterestTableComponent {
  restrictedData: boolean;
  tableColumns: string[];
  tableData: CreditInterest[];
  emptyValuePlaceholder = '-';
  errorText: string;
  showTable: boolean;

  constructor(public dialog: MatDialog) {
    this.tableColumns = [];
    this.tableData = [];
  }

  getAmount(value, currency: string) {
    if (this.restrictedData) {
      return value;
    } else {
      if (value || value === 0) {
        value = formatCurrency(value, 'nl', '€', currency);
      } else {
        value = this.emptyValuePlaceholder;
      }
      return value;
    }
  }
  getAmountInPercentage(value) {
    if (this.restrictedData) {
      return value;
    } else {
      if (value || value === 0) {
        value = formatNumber(value, 'en-US', '1.3-3');
      } else {
        value = this.emptyValuePlaceholder;
      }
      return value;
    }
  }
}
